/* ----------------- React Native Paper --------------- */
import { Card } from "react-native-paper";

/* ----------------- Types --------------- */
import type { CheckboxStateMap, Section } from "./types";

import Button from "../../Button";
import CardContainer from "../../CardContainer";
/* ----------------- Child components --------------- */
import CardContent from "./CardContent";

export type StudySessionPerformanceCardProps = {
	title: string;
	subtitle: string;
	sections: Section[];
	handleReviewButtonClick: () => void;
	handleChangeCheckboxStateMap: (key: keyof CheckboxStateMap) => void;
	checkboxStateMap: CheckboxStateMap;
	showReview?: boolean;
};
const StudySessionPerformanceCard = ({
	title,
	subtitle,
	sections,
	handleReviewButtonClick,
	checkboxStateMap,
	handleChangeCheckboxStateMap,
	showReview,
}: StudySessionPerformanceCardProps) => {
	const ActionsCard = () => (
		<Card.Actions
			style={{
				justifyContent: "flex-end",
			}}
		>
			<Button mode="text" onPress={handleReviewButtonClick}>
				Review answers
			</Button>
		</Card.Actions>
	);

	return (
		<>
			<CardContainer
				title={title}
				subtitle={subtitle}
				icon="arm-flex-outline"
				actions={showReview && <ActionsCard />}
			>
				<CardContent
					sections={sections}
					checkboxStateMap={checkboxStateMap}
					handleCheckboxStateMapChange={(type) => {
						handleChangeCheckboxStateMap(type);
						handleReviewButtonClick();
					}}
					showReview={showReview}
				/>
			</CardContainer>
		</>
	);
};

export { CardContent, StudySessionPerformanceCard };
